import axios, { AxiosResponse } from "axios";

export type TCreateOneTimeTokenRequest =
  | {
      email: string;
    }
  | { phone: string };

type TTokenSignInRequest = {
  token: string;
  userId: string;
};

export const createOneTimeToken = async (
  request: TCreateOneTimeTokenRequest
): Promise<any> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/token/create`, request);
};

export const tokenSignIn = async (
  request: TTokenSignInRequest
): Promise<any> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/token/sign-in`, request, {
    withCredentials: true,
  });
};

export const tokenSignOut = async (): Promise<AxiosResponse> =>
  axios.post(`${process.env.REACT_APP_API_URL}/token/sign-out`, null, {
    withCredentials: true,
  });
